/**
 * @generated SignedSource<<55bd5100cd9bfeca975d2cfff5c68ec3>>
 * @relayHash 8d03040d688843528ead855771e8246c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00

import type { ConcreteRequest } from 'relay-runtime';
export type useCurrentUserContributorContentContributorsQuery$variables = {
  contentId: string;
};
export type useCurrentUserContributorContentContributorsQuery$data = {
  readonly contentContributors: {
    readonly isCurrentUserContributor: boolean | null;
  } | null;
};
export type useCurrentUserContributorContentContributorsQuery = {
  response: useCurrentUserContributorContentContributorsQuery$data;
  variables: useCurrentUserContributorContentContributorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentContributors",
    "kind": "LinkedField",
    "name": "contentContributors",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCurrentUserContributorContentContributorsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCurrentUserContributorContentContributorsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d03040d688843528ead855771e8246c",
    "id": "e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00",
    "metadata": {},
    "name": "useCurrentUserContributorContentContributorsQuery",
    "operationKind": "query",
    "text": "query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
  }
};
})();

(node as any).hash = "3529cb3bd09c95342e2b9b31b917a3c4";

export default node;
